import { Link } from "react-router-dom";
import { COMPANY, formatAddress, telHref } from "../../config/company";
import "./companycontact.scss";

const CompanyContact = ({ onCallback, buttonClassName = "btn-secondary-inverse" }) => {
  return (
    <div className="solar__footer" id="kapcsolat">
      <div className="solar__footer__container company-contact">
        <h2>{COMPANY.shortName}</h2>
        <address style={{ fontSize: "0.8rem", fontStyle: "normal" }}>
          <p>Székhely: {formatAddress()}</p>
          {COMPANY.emails.map((email) => (
            <p key={email}>
              <a href={`mailto:${email}`}>{email}</a>
            </p>
          ))}
          {COMPANY.phones.map((phone) => (
            <p key={phone}>
              <a href={telHref(phone)}>{phone}</a>
            </p>
          ))}
          <p className="company-contact__legal">
            Adószám: {COMPANY.taxNumber} · Cégjegyzékszám:{" "}
            {COMPANY.registrationNumber}
          </p>
          <p className="company-contact__links">
            <Link to="/impresszum">Impresszum</Link>
            {" · "}
            <Link to="/aszf">ÁSZF</Link>
            {" · "}
            <Link to="/adatkezelesi-tajekoztato">Adatkezelési tájékoztató</Link>
          </p>
        </address>
        {onCallback && (
          <div className="solar__footer__container__btns">
            <button className={buttonClassName} onClick={onCallback}>
              Visszahívást kérek
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyContact;
